// src/components/HeroFleetTabs.jsx
import React, { useEffect, useState, useRef } from "react";

/**
 * Props (optional):
 *  - tabs: array of { key, label, images: [img1, img2, ...] }
 *  - interval: ms between image switches (default 3000)
 *
 * Replace the sample image imports/paths below with your own.
 */

// SAMPLE images - replace with your assets
// import hatch1 from "../../images/cars/car1.png";
// import hatch2 from "../../images/cars/car2.png";
// import econ1 from "../../images/cars/car3.png";
// import econ2 from "../../images/cars/car4.png";
// import lux1 from "../../images/cars/car1.png";
// import lux2 from "../../images/cars/car2.png";
// import suv1 from "../../images/cars/car1.png";
// import suv2 from "../../images/cars/car2.png";
// car2
import ertiga from "../../images/car2/ertiga.png";
import innova from "../../images/car2/innova.png";
import xyl from "../../images/car2/xyl.png";
// car1
import amaze from "../../images/car1/amaze.png";
import aura from "../../images/car1/aura.png";
import dzire from "../../images/car1/dzire.png";
import etios from "../../images/car1/etios.png";
import togor from "../../images/car1/togor.png";
import xcent from "../../images/car1/xcent.png";
import { Fade } from "react-awesome-reveal";
import sideArrow from "../../images/icons/sideArrow.png";

export default function CarTypes({ interval = 6000, tabs }) {
  // Manual Navigation
  const goPrev = () => {
    setActiveImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveImageIndex((prev) => (prev + 1) % images.length);
  };
  const defaultTabs = [
    {
      key: "Sedan",
      label: "Sedan",
      images: [
        { src: amaze, name: "Amaze" },
        { src: xcent, name: "Xcent" },
        { src: aura, name: "Aura" },
        { src: dzire, name: "Dzire" },
        { src: etios, name: "Etios" },
        { src: togor, name: "Tigor" },
      ],
    },
    {
      key: "SUV / MPV",
      label: "SUV / MPV",
      images: [
        { src: ertiga, name: "Ertiga" },
        { src: innova, name: "Innova" },
        { src: xyl, name: "Xylo" },
      ],
    },
    // { key: "luxury", label: "Luxury Sedan", images: [hatch1, hatch2] },
    // { key: "suv", label: "SUV / MUV", images: [hatch1, hatch2] },
  ];

  const items = tabs && tabs.length ? tabs : defaultTabs;

  const [activeKey, setActiveKey] = useState(items[0].key); // default first tab selected
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const timerRef = useRef(null);

  // Find active tab object
  const activeTab = items.find((t) => t.key === activeKey) || items[0];
  const images = activeTab.images || [];

  // Start/Restart slideshow for active tab
  useEffect(() => {
    // reset to first image when tab changes
    setActiveImageIndex(0);

    // clear previous interval
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // if less than 2 images, no need to cycle
    if (!images || images.length < 2) return;

    timerRef.current = setInterval(() => {
      setActiveImageIndex((prev) => (prev + 1) % images.length);
    }, interval);

    // cleanup on unmount or tab change
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, interval]); // restart when activeKey or interval changes

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <section className="relative overflow-hidden bg-white">
      <Fade direction="up" triggerOnce ascade damping={0.2}>
        <div className="max-w-8xl mx-auto px-6 md:px-10 py-12 md:py-20">
          <div className="text-center">
            <p className="text-xs md:text-sm text-gray-500 md:h-[26px] mb-2 md:mb-0">
              Our Fleet
            </p>

            <h1 className="mb-6 text-2xl md:text-4xl content-center  md:h-[62px]  font-bold leading-tight text-gray-900 max-w-3xl mx-auto">
              Choose the Right Car for Your Business
            </h1>

            <p className=" max-w-5xl font-medium mx-auto text-sm md:text-[18px] text-gray-500">
              Select from our wide range of well-maintained vehicles designed
              for comfort, class, and convenience.
            </p>

            {/* Tabs */}
            <nav className="mt-8 " aria-label="Vehicle types">
              <ul className="inline-flex items-center gap-4 md:gap-8 text-sm md:text-base">
                {items.map((t) => (
                  <li key={t.key}>
                    <button
                      onClick={() => setActiveKey(t.key)}
                      className={`px-1 pb-1 border-b-2  transition-all duration-200 ${
                        t.key === activeKey
                          ? "border-[#C59B61] md:text-[24px] font-semibold text-[#C59B61]"
                          : "border-transparent text-[#C59B61] md:text-[20px] font-medium "
                      }`}
                      aria-current={t.key === activeKey ? "true" : undefined}
                    >
                      {t.label}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Images area */}
          <div className="mt-32 md:mt-96 flex justify-center">
            <button
              onClick={goPrev}
              className="absolute left-4 md:left-36 top-2/3 -translate-y-1/2 
        bg-white/80 hover:bg-white shadow-lg p-3 rounded-full z-20
        transition cursor-pointer"
            >
              <img
                src={sideArrow}
                className="w-2 h-2 md:w-5 md:h-5 object-contain "
                alt="left arrow"
              />
            </button>

            {/* RIGHT ARROW */}
            <button
              onClick={goNext}
              className="absolute right-4 md:right-36 top-2/3 -translate-y-1/2 
        bg-white/80 hover:bg-white shadow-lg p-3 rounded-full z-20
        transition cursor-pointer"
            >
              <img
                src={sideArrow}
                className="w-2 h-2 md:w-5 md:h-5 rotate-180 object-contain"
                alt="right arrow"
              />
            </button>

            <div className="relative w-full max-w-[900px]">
              {/* spacer to create room for overlap like design */}
              {/* Image container - will show single image at a time with fade */}
              <div className="h-[36px] md:h-[48px] lg:h-[72px]" />
              <div className="relative mx-auto w-full flex justify-center items-end">
                {/* LEFT ARROW */}

                {images && images.length > 0 ? (
                  images.map((src, idx) => {
                    const visible = idx === activeImageIndex;
                    return (
                      <img
                        key={idx}
                        src={src.src}
                        alt={`${activeTab.label} ${idx + 1}`}
                        className={`absolute bottom-0 mx-auto block object-contain transition-opacity duration-700 ease-in-out
                        ${
                          visible
                            ? "opacity-100 pointer-events-auto"
                            : "opacity-0 pointer-events-none"
                        }
                        w-[220px] md:w-[420px] lg:w-[560px]`}
                        style={{
                          filter: "drop-shadow(0 20px 30px rgba(0,0,0,0.15))",
                          transform: visible
                            ? "translateY(0)"
                            : "translateY(6px)",
                        }}
                      />
                    );
                  })
                ) : (
                  <div className="w-full h-40 bg-gray-100 rounded-md flex items-center justify-center">
                    <span className="text-sm text-gray-400">No images</span>
                  </div>
                )}
              </div>
              {/* Car Name */}
              {/* Car Name */}
              <div className="mt-6 text-center">
                <p className="text-lg md:text-xl font-semibold text-[#C59B61]">
                  {images[activeImageIndex]?.name}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
}
